import * as types from '../actions/userprofileactiontypes'
const initialState = {

}
initialState.updateUserProfile = {
    userFullName: null,
    newPassword:null,    
    confirmPassword: null,
    oldPassword:null,
    passwordMeter:false,
    updatePasswordMessage:null,
}
export default function userProfileReducer(state = initialState, action){
    switch(action.type){
    
        case types.UPDATE_USER_PROFILE:
            let {name, value} = action.payload
            return {
                ...state,
                updateUserProfile: {
                    ...state.updateUserProfile,
                    [action.payload.name]: action.payload.value
                }
            }
            case types.CLEAR_PASSWORD_PARAMS:
               
                return {
                    ...state,
                    updateUserProfile: {
                        ...state.updateUserProfile,
                            newPassword:null,    
                            confirmPassword: null,
                            oldPassword:null,
                            passwordMeter:false,
                            updatePasswordMessage:null,
                    }
                }
                case types.PASSWORD_METER_PARAMS:
                    return {
                        ...state,
                        updateUserProfile: {
                            ...state.updateUserProfile,
                            passwordMeter: true
                        }
                    }
                
  
        default:
        return state;
    }
}



